import { withStyles, WithStyles } from "@material-ui/core/styles";
import React from "react";
import { Link, Typography } from "@material-ui/core";
import { styles } from "./Breadcrumbs.styles";
import BreadcrumbsMUI from "@material-ui/core/Breadcrumbs/Breadcrumbs";
import { useHistory } from "react-router-dom";

interface IBreadcrumbsItem {
    title: string;
    href?: string;
}
interface IBreadcrumbsProps extends WithStyles<typeof styles> {
    items: IBreadcrumbsItem[];
}

const BreadcrumbsPure: React.FunctionComponent<IBreadcrumbsProps> = ({ classes, items }: IBreadcrumbsProps) => {
    const lastItem = items.pop();
    const history = useHistory();

    const handleClick = (event, href) => {
        event.preventDefault();
        history.push(href);
    };
    return (
        <BreadcrumbsMUI aria-label="breadcrumb" className={classes.root}>
            {items.map((item, index) => (
                <Link className={classes.link} href={item.href} onClick={event => handleClick(event, item.href)} key={index}>
                    {item.title}
                </Link>
            ))}
            <Typography className={classes.nonLink} >{lastItem.title}</Typography>
        </BreadcrumbsMUI>
    );
};

export const Breadcrumbs = withStyles(styles)(BreadcrumbsPure);
